import {
  Box,
  Typography
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import type { TFunction } from "i18next";
import { getModalEditionChangeStyles } from "./ModalEditionChange.style";
import mapPinned from "../../assets/map-pinned.svg";

interface EditionHeaderProps {
  editionId: number;
  code?: string;
  location?: string;
  isVirtual: boolean;
  theme: Theme;
  t: TFunction;
}

export function EditionHeader({ editionId, code, location, isVirtual, theme, t }: EditionHeaderProps) {
  const styles = getModalEditionChangeStyles(theme);
  return (  <Box sx={ { alignItems: "center", display: "flex" } }>
    <Typography sx={ styles.editionHeader.text }>
      { t("edition_name") } { editionId }
    </Typography>
    { code && (
      <>
        <Typography component="span" sx={ { ...styles.editionHeader.text, mx: 0.5 } }>|</Typography>
        <Typography variant="body2" sx={ styles.editionHeader.text }>
          { t("code_field") }: { code }
        </Typography>
      </>
    ) }
    { !isVirtual && location && (
      <>
        <Typography component="span" sx={ { ...styles.editionHeader.text, mx: 0.5 } }>|</Typography>
        <img
          alt="map-pinned"
          src={ mapPinned }
          width="16px"
          height="16px"
          style={ { filter: "brightness(0) invert(1)" } }
        />
        <Typography variant="body2" sx={ { ...styles.editionHeader.text, ml: 0.5 } }>
          { location }
        </Typography>
      </>
    ) }
  </Box>
  );
}
